﻿import * as React from "react";
import { IActiveSectionProps } from "../";
import { IBaseSectionProps } from "./Sections/IBaseSectionProps";
import { IToolFrameProps } from "../ToolFrame/index";
import { IToolProps } from "./Tool";
import { SectionLoader } from "./Sections";

export interface ITabProps {
    activeSections: IActiveSectionProps[];
    activeTool: IToolFrameProps;
    bindToolToFrame: (
        moduleID: number,
        displayName: string,
        toolLookup: string,
        toolUrl: string,
    ) => void;
    displayOrder: number;
    id: number;
    isDivider: boolean;
    name: string;
    openSection: (
        tools: IToolProps[],
        moduleID: number,
        displayName: string,
        toolLookup: string,
        toolUrl: string,
    ) => void;
    sections: IBaseSectionProps[];
    toggleSection: (
        section: IActiveSectionProps,
        comparatorinator: (
            activeSections: IActiveSectionProps[],
        ) => IActiveSectionProps[],
    ) => void;
    updateSection: (section: IActiveSectionProps) => void;
}

export const Tab: React.FunctionComponent<ITabProps> = (
    props,
): React.ReactElement => {
    const loader: SectionLoader = new SectionLoader(props),
        sectionList: React.ReactNode[] = [];

    for (let i = 0; i < props.sections.length; i++) {
        sectionList.push(
            loader.getSection(props.sections[i], props.sections[i].sectionType),
        );
    }

    return (
        <div className={`toolbar-tab ${props.isDivider ? `last` : ``}`}>
            {sectionList}
        </div>
    );
};
